import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Select, MenuItem, Tooltip, InputAdornment, CircularProgress, Checkbox, FormControlLabel } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import FileUploadGroup from './FileUploadGroup';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { useForm, Controller } from 'react-hook-form';
import HelpIcon from '@mui/icons-material/Help';
import * as charityActions from '../../store/actions/charitableActivity';
import InputMask from 'react-input-mask';
import { useLogout } from '../../components/Utils';
import constants from '../../config/constants';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};
const textboxCss2 = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "11px 14px 10px  14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid transparent`,

    },
    '& .MuiInputBase-fullWidth': {
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
        paddingRight: '10px !important'
    },
    '& fieldset' : {
        borderColor : 'transparent'
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};
const textboxCss1 = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "11px 14px 10px  0",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid transparent`,

    },
    '& .MuiInputBase-fullWidth': {
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
        paddingRight: '10px !important'
    },
    '& fieldset' : {
        borderColor : 'transparent'
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const CreateCharitableActivity = ({setBreadcrumb, createNewCharitableActivity, createdCharityData, getBUnitFilterDetails, bunitFilterList}) => {
    const { t } = useTranslation('common');

    const params = useLocation();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
    const [apiErr, setApiErr] = useState('');
    const [filterList, setFilterList] = useState([]);
    const [businessNameList, setBusinessNameList] = useState([]);
    const [businessName, setBusinessName] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedAddress, setSelectedAddress] = useState('');
    const [selectedBusinessLocationList, setSelectedBusinessLocationList] = useState([]);
    const [givingErr, setGivingErr] = useState(false);
    const [uploadImageError, setUploadImageError] = useState('');
    const [bulkUploadData, setBulkUploadData] = useState(null);
    const [activityStartDate, setActivityStartDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activityType, setActivityType] = useState('charity');
    const onLogout = useLogout();

    useEffect(() => {
        const subMenuData = {
            name: t("Charitable Activities"),
            route: "/charitable-activity",
            subRoutes: "create-charitable-activity",
            subRoutesLabel: t("Create"),
            isSubMenu: true
        }

        setBreadcrumb(subMenuData)
      }, []);

    const handleFormSubmit = (data) => {
            if(!Object?.keys(errors)?.length){
                sendFormValues(data);
            }
    }
    const sendFormValues = async (formData) => {
        if ((formData?.totalmartinreafunds === "" || Number(formData?.totalmartinreafunds) === 0 ) && (formData?.amountofemployee === "" || Number(formData?.amountofemployee) === 0) && (formData?.volunteerHours === "" || Number(formData?.volunteerHours) === 0)) {
            setGivingErr(true);
            return;
          } else {
            setIsLoading(true);
            const form = new FormData();
            form.set("businessUnitId",formData?.businessName);
            form.set("businessLocationId", formData?.location);
            form.set("eventName", formData.eventname?.trim());
            form.set("charityName", formData?.charityname?.trim());
            form.set("comments", formData?.comments?.trim());
            form.set("totalAmount", formData?.totalmartinreafunds);
            form.set("employeeFund", formData?.amountofemployee);
            form.set("volunteerHours", formData?.volunteerHours);
            form.set("eventStartDate", formData?.fromDate ? moment(formData?.fromDate).format('YYYY-MM-DD') : '',);
            form.set("eventEndDate", formData?.fromDate ? moment(formData?.fromDate).format('YYYY-MM-DD') : '',);
            form.set("activityType", activityType);
            if (bulkUploadData?.length > 0) {
                bulkUploadData.forEach((file, index) => {
                    form.append('uploadFiles', file, file.name);
                });
                form.append('bucketName', constants.FILE_UPLOAD_BUCKETNAME);
            }            
            // if(bulkUploadData?.length > 0) {
            //     let result = await charityActions.uploadFilesToCloudStorage(bulkUploadData);
            //     form.set("fileDetails", JSON.stringify(result?.uploadedFiles));
            // }
            createNewCharitableActivity(form)
        }
    }

    useEffect(() => {
        if(createdCharityData && createdCharityData.status === 200) {
            setIsLoading(false);
            navigate('/charitable-activity');
        }
        else if (createdCharityData && createdCharityData.status === 403){
            setIsLoading(false);
            setApiErr(createdCharityData.message)
        } else if (createdCharityData && createdCharityData.status === 401){
            setIsLoading(false);
            onLogout();
        }
    }, [createdCharityData]);

    useEffect(()=>{
        getBUnitFilterDetails();
      },[])

    useEffect(()=>{
    if(bunitFilterList && bunitFilterList?.status === 200){
        const dataArr = bunitFilterList?.data || []
        setFilterList(dataArr);
        const businessInfoList = dataArr
        .filter((businessUnit) => businessUnit?.businessLocation?.some(location => location?.isSelected))
        .map((businessUnit) => ({
            businessUnitId: businessUnit.businessUnitId,
            businessUnitName: businessUnit.businessUnitName,
          }));

          const isSelectedArray = bunitFilterList?.data
            .flatMap(item => {
              const selectedLocations = item?.businessLocation?.filter(location => location?.isSelected) || [];
              if (selectedLocations.length > 0) {
                return {
                  businessUnitId: item.businessUnitId,
                  businessUnitName: item.businessUnitName,
                  businessLocation: selectedLocations,
                };
              }
              return [];
            });
            if (isSelectedArray?.length === 1 && isSelectedArray[0]?.businessLocation?.length === 1) { 
                loadLoaction(isSelectedArray[0]);
            } else {
                setBusinessNameList(businessInfoList)
            }

        // const businessNames = dataArr.map((businessUnit) => businessUnit.businessUnitName);
        // setBusinessNameList(businessInfoList)
    } else if (bunitFilterList && bunitFilterList?.status === 401){
        onLogout();
    }
    },[bunitFilterList])
    const loadLoaction = async(data) =>{
        const location = await charityActions.getBUnitFilterDetailsPreload();
        
        if(location?.data){
           
            setFilterList(location?.data);
           const businessInfoList = location?.data?.filter((businessUnit) => businessUnit?.businessLocation?.some(location => location?.isSelected))
            .map((businessUnit) => ({
                businessUnitId: businessUnit?.businessUnitId,
                businessUnitName: businessUnit?.businessUnitName,
              }));
              
              const businessUnit = location?.data?.find((unit) => unit?.businessUnitId === data?.businessUnitId);
              const locationArray = businessUnit ? businessUnit?.businessLocation?.filter((location) => location?.isSelected) : [];
              const address = getAddress(data?.businessUnitId,data?.businessLocation[0]?.id, location?.data)


            setSelectedBusinessLocationList(locationArray)
            setBusinessNameList(businessInfoList)
            setBusinessName(data?.businessUnitId)
            setValue("businessName",data?.businessUnitId)
            
            setSelectedLocation(data?.businessLocation[0]?.id)
            setValue("location",data?.businessLocation[0]?.id)


            setValue("address",address || '')
            setSelectedAddress(address  || '')

            setValue()
        }
    }
    // const getBusinessLocation = (businessName) => {
    // const businessUnit = filterList.find((unit) => unit.businessUnitId === businessName);
    // return businessUnit ? businessUnit.businessLocation : [];
    // };
    const getBusinessLocation = (businessUnitId) => {
        const businessUnit = filterList.find((unit) => unit.businessUnitId === businessUnitId);
        if (businessUnit) {
          return businessUnit.businessLocation.filter((location) => location.isSelected);
        } else {
          return [];
        }
      };
    const getAddress = (businessName, id, locationData) => {
        const arrayList = locationData || filterList;
        const businessUnit = arrayList?.find((unit) => unit.businessUnitId === businessName);
        if (businessUnit) {
            const location = businessUnit.businessLocation.find((loc) => loc.id === id);
            const dataobj = {
            address: location ? location.address : null,
            currency: location ? location.currency : 'cad'
            }
            return dataobj;
        }
        
        return null;
    };

    const handleSelectedFiles = (files,  selectedFiles) => {
        setBulkUploadData(selectedFiles);
    };
        
    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("Charitable Activities")}</b></h1>
                </Grid>
            </Grid>
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Business Unit")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="businessName"
                                control={control}
                                {...register('businessName', { required: true })}
                                render={({ field }) => (
                                <Select
                                    {...field}
                                    value={businessName}
                                    onChange={(e) => {
                                    field.onChange(e);
                                    setSelectedBusinessLocationList(getBusinessLocation(e.target.value));
                                    setBusinessName(e.target.value);
                                    setValue("businessName", e.target.value)
                                    setValue("location", '')
                                    setSelectedAddress(null)
                                    }}
                                    className='normal-dropdown xxs-normal'
                                    inputProps={{ 'aria-label': 'Business Name' }}
                                >
                                    {businessNameList?.map((item, i) => (
                                    <MenuItem className='xxs-normal filter-item' key={i} value={item.businessUnitId}>
                                        {item.businessUnitName}
                                    </MenuItem>
                                    ))}
                                </Select>
                                )}
                            />

                        </div>
                        {errors?.businessName?.type === "required" && <span style={ErrorStyle}>{t("Please enter business unit name")}</span>}
                        
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Location")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="location"
                                control={control}
                                {...register('location', { required: true })}
                                render={({ field }) => (
                                <Select
                                    {...field}
                                    value={selectedLocation}
                                    // value={field.value || ''}
                                    onChange={(e) => {
                                    field.onChange(e);
                                    setSelectedLocation(e.target.value)
                                    setValue("location", e.target.value)
                                    setSelectedAddress(getAddress(businessName, e.target.value));
                                    }}
                                    className='normal-dropdown xxs-normal'
                                    inputProps={{ 'aria-label': 'location' }}
                                >
                                    {selectedBusinessLocationList?.map((item, i) => (
                                    <MenuItem className='xxs-normal filter-item' key={i} value={item.id}>
                                        {item.locationName}
                                    </MenuItem>
                                    ))}
                                </Select>
                                )}
                            />
                        </div>
                        {errors?.location?.type === "required" && <span style={ErrorStyle}>{t("Please enter the location")}</span>}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Address")} </Typography>
                            <TextField
                                {...register('address')}
                                margin="normal"
                                id="address"
                                sx={textboxCss}
                                value={selectedAddress?.address   || ''}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "address" }}
                            />
                        </div>
                    </Grid>
                    
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Activity Date")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="fromDate"
                                control={control}
                                rules={{ required: t("Activity date is required") }}
                                render={({ field, fieldState }) => (
                                    <>
                                <DatePicker
                                    {...field}
                                    sx={textboxCss}
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                    className='input-text-box mt-0' 
                                    onChange={(date) => {
                                        field.onChange(date);
                                        setActivityStartDate(date)
                                      }}
                                    format="MM/dd/yyyy" 
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        error={!!fieldState.error}
                                        helperText={fieldState.error ? fieldState.error.message : null}
                                        label= {t("Select Date")}
                                    />
                                    )}
                                />
                                {errors.fromDate && <span style={ErrorStyle}>{errors.fromDate.message}</span>}
                                </>
                                )}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div>
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>
                                {t("Activity Type")} <span style={{color:"red"}}>{" *"}</span>
                            </Typography>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={activityType === 'charity'}
                                            onChange={() => setActivityType('charity')}
                                            sx={{ color: appConfig.colors.darkblue, '&.Mui-checked': { color: appConfig.colors.darkblue } }}
                                        />
                                    }
                                    label={<Typography component="span" className='xxs-normal' sx={{ color: appConfig.colors.black }}>{t("Charity")}</Typography>}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={activityType === 'hr_event'}
                                            onChange={() => setActivityType('hr_event')}
                                            sx={{ color: appConfig.colors.darkblue, '&.Mui-checked': { color: appConfig.colors.darkblue } }}
                                        />
                                    }
                                    label={<Typography component="span" className='xxs-normal' sx={{ color: appConfig.colors.black }}>{t("HR Event")}</Typography>}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div>
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Charity Name")}</Typography>
                            <TextField
                                {...register('charityname')}
                                margin="normal"
                                id="charityname"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "charity name", maxLength: 100 }}
                            />
                        </div>
                        {apiErr !== '' && (<span style={ErrorStyle}>{apiErr}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Activity Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('eventname', { required: true, validate: value => value.trim() !== '' || t("Please enter activity name")})}
                                margin="normal"
                                id="name"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "event name" , maxLength: 100}}
                            />
                        </div>
                        {(errors?.eventname?.type === "required" || errors?.eventname?.type === "validate") && <span style={ErrorStyle}>{t("Please enter activity name")}</span>}
                        {errors?.eventname?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters not allowed")}</span>)}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mt: 1, color: appConfig.colors.black, background: appConfig.colors.lightGray, padding: "10px !important" }} className='xxs-bold'>{t("Giving Amounts")}</Typography>
                        {givingErr && (<span style={ErrorStyle}>{t("At least one of three Giving Amounts field is required")}</span>)}
                    </Grid>     
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Total Amount of funds Martinrea international (company not employee) has donated to this activity?")}&nbsp;
                            <Tooltip title={t("These are funds provided by your location that are usually driven by HR and/or your GM through sponsorships, charity events etc")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <TextField
                                {...register('totalmartinreafunds', { 
                                    pattern: {
                                        value: /^\d*\.?\d*$/,
                                        message: "Please enter a valid number with only one decimal point"
                                    },
                                    validate: value => {
                                        const valueStr = String(value);
                                        return (valueStr.match(/\./g) || []).length <= 1 || "Only one decimal point is allowed";
                                    }
                                })}
                                margin="normal"
                                id="totalmartinreafunds"
                                sx={textboxCss1}
                                className='input-box'
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" style={{paddingLeft: 15, fontSize: 14, fontFamily: appConfig.fontfamily, textTransform: 'uppercase'}}><span style={{fontSize: 14}}>{selectedAddress?.currency}</span></InputAdornment>,
                                }}
                                inputProps={{ "aria-label": "total funds", maxLength: 10 }}
                            />
                        </div>
                        {errors?.totalmartinreafunds?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters and alphabets not allowed")}</span>)}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Total Amount of employee raised funds?")}&nbsp;
                            <Tooltip title={t("These are funds that are primarily raised or driven by employee fundraising through bake sales, raffles, etc.")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <TextField
                                {...register('amountofemployee', {
                                    pattern: {
                                        value: /^\d*\.?\d*$/,
                                        message: "Please enter a valid number with only one decimal point"
                                    },
                                    validate: value => {
                                        const valueStr = String(value);
                                        return (valueStr.match(/\./g) || []).length <= 1 || "Only one decimal point is allowed";
                                    }
                            
                                } )}
                                margin="normal"
                                id="amountofemployee"
                                sx={textboxCss1}
                                className='input-box'
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" style={{paddingLeft: 15, fontSize: 14, fontFamily: appConfig.fontfamily, textTransform: 'uppercase'}}><span style={{fontSize: 14}}>{selectedAddress?.currency}</span></InputAdornment>,
                                }}
                                inputProps={{ "aria-label": "amount of employee", maxLength: 10 }}
                            />
                        </div>
                        {errors?.amountofemployee?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters and alphabets not allowed")}</span>)}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Estimated Volunteer hours donated to this activity?")} </Typography>
                            <Controller
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                render={({ field: { onChange, onBlur, value } }) => (
                                    <TextField
                                        {...register('volunteerHours', {required: false, pattern: /^[0-9 ]+$/})}
                                        onBlur={onBlur}
                                        margin="normal"
                                        sx={textboxCss2}
                                        className='input-box s-normal'
                                        fullWidth
                                        inputProps={{ "aria-label": "volunteerHours", maxLength: 5 }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">{t("Hours")}</InputAdornment>,
                                        }}
                                        onChange={(e) => {
                                            onChange(e.target.value);
                                        }}
                                        value={value}
                                    />
                                )}
                                name="volunteerHours"
                                defaultValue=""  
                            />
                        </div>
                        {errors?.volunteerHours?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters and alphabets not allowed")}</span>)}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mt: 1, color: appConfig.colors.black, background: appConfig.colors.lightGray, padding: "10px !important" }} className='xxs-bold'>{t("Stories & Attachments")}</Typography>
                    </Grid>  
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Comment/Stories on the Impact of Giving")}   <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('comments', { required: true, validate: value => value.trim() !== '' || t("Please enter comments/stories")})}
                                margin="normal"
                                id="comments"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "comments", maxLength: 2500 }}
                                placeholder=""
                                multiline
                                rows={3}
                                maxRows={3}
                            />
                        </div>
                        {(errors?.comments?.type === "required" || errors?.comments?.type === "validate")&& <span style={ErrorStyle}>{t("Please enter comments/stories")}</span>}
                    </Grid>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div>                            
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Upload photos and/or videos")}&nbsp;
                            <Tooltip title={t("Please attach images separately as high resolution JPG/PNG/JPEG/GIF/BMP/WEBP and videos MP4/WEBM/OGG/MKV/AVI files, NOT embedded in other document types such as Word or PowerPoint")} arrow placement="top" style={{position: 'relative', top: 3, cursor: 'pointer'}}>
                                <span><HelpIcon fontSize='10px'/></span>
                            </Tooltip>
                            </Typography>
                            <FileUploadGroup onFilesChange={handleSelectedFiles} />
                        </div>
                    </Grid>
                </Grid>
                
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                        <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            disabled={isLoading}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/charitable-activity')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid>
                    
                </Grid>
            </form>
    </div >
}





const mapStateToProps = (state) => ({ 
    createdCharityData: state.charitableActivity.createdCharityData,
    bunitFilterList: state.charitableActivity.bunitFilterList,
 })
 const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        createNewCharitableActivity: (data) => dispatch(charityActions.createNewCharitableActivity(data)),
        getBUnitFilterDetails: () => dispatch(charityActions.getBUnitFilterDetails()),
    };
}
 CreateCharitableActivity.propTypes = {
    createNewCharitableActivity: PropTypes.func.isRequired,
    setBreadcrumb: PropTypes.func.isRequired,
    getBUnitFilterDetails: PropTypes.func.isRequired,
}


export default connect(mapStateToProps, mapDispatchToProps)(CreateCharitableActivity);
